export default [
{
    path: 'customList',
    name: {list:['数字店铺','运营','店铺装修','移动端装修']},
    component: () => import('@/views/customPage/list/index.vue')
},
{
    path: 'sharingApplets',
    name: {list:['数字店铺','运营','店铺装修','店铺推广']},
    component: () => import('@/views/customPage/sharingApplets/index.vue')
},
{
    path: 'miniPage',
    name: {list:['数字店铺','运营','微页面','微页面']},
    component: () => import('@/views/customPage/miniPage/index.vue')
}
]